import { render, staticRenderFns } from "./comp_BookPreview.vue?vue&type=template&id=7c058792&scoped=true&"
import script from "./comp_BookPreview.vue?vue&type=script&lang=js&"
export * from "./comp_BookPreview.vue?vue&type=script&lang=js&"
import style0 from "./comp_BookPreview.vue?vue&type=style&index=0&id=7c058792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c058792",
  null
  
)

export default component.exports